<template lang="pug">
  button.btn.btn-danger(type="button" @click.prevent="modalConf.isOpen = true" title="一括削除" data-testid="-btn-bulk-delete"): i.fa.fa-trash

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    //- 名刺交換履歴の削除
    portal(to="modal")
      app-modal(type="danger" v-model="modalConf.isOpen" data-testid="bcard-exchange-bulkdelete-modal")
        template(slot="title") 名刺交換履歴の削除
        h4 あなたの名刺交換履歴をすべて削除します。よろしいですか？
        p.text-danger ※すべての名刺交換履歴が削除されると、その名刺情報も削除されます。
        template(slot="footer" slot-scope="{close}")
          button.btn.btn-danger(type="button", :disabled="modalConf.isExec",  @click.prevent="submit(); close();", data-testid="-btn-delete") 削除
          button.btn.btn-default(type="button" @click.prevent="close") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const ExchangeRepository = RepositoryFactory.get('exchange')

export default {
  name: 'FuncDelCard',
  components: { AppModal },
  props: {
    sidPerson: { type: [String, Number], required: false, default: '' }
  },
  data: function () {
    return {
      // modalNoItem: false,
      modalConf: {
        isOpen: false,
        isExec: false
      }
    }
  },
  methods: {
    submit () {
      if (!this.sidPerson) return

      const vm = this

      this.modalConf.isExec = true
      ExchangeRepository.deleteAll(this.sidPerson)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.$emit('success')
            vm.showToast('あなたの名刺交換履歴をすべて削除しました。', { type: 'success' })
            vm.modalConf.isOpen = false
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺交換履歴を削除できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
        .finally(function () {
          vm.modalConf.isExec = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/functions/FuncDelExchange.vue